import _ from "lodash";
import React from "react";
import classes from "./TagPostV2.scss";
import { connect } from "react-redux";
import { compose } from "lib/apolloClient";
import I18nHOC from "UIComponents/I18nHOC";

import { updatePost } from "Post/modules/PostModule";
import { getUserInfo } from "Login/modules/LoginModule/LoginUtils";
import PostList from "./PostList/PostList";

import { Modal } from "@toddle-edu/ds-web";
import {
  getIsNewGoalTaggingEnabled,
  isUnitPlanOrAssessmentTagged,
} from "Post/utils";

function TagPost(props) {
  const {
    t,
    curriculumProgramType,
    feedList,
    updatePost,
    userType,
    screenPanelProps,
  } = props;
  const { onCloseClick, goToStep } = screenPanelProps;
  const onPostClicked = post => {
    const resourceId = _.get(post, "node.resourceItem.id");
    const unitPlanId = _.get(post, "node.unitPlan.id");
    const postTaggedElements = {};
    const postTaggedPYPChildren = [];
    _.forEach(_.get(post, "node.elementPYP", []), element => {
      const cloneElement = _.cloneDeep(element);
      if (!_.isEmpty(cloneElement?.id)) {
        postTaggedElements[cloneElement?.id] = {
          fieldUID: cloneElement?.fieldUID || cloneElement?.id,
          id: cloneElement?.id || cloneElement?.fieldUID,
          value: cloneElement?.value,
          parentType: cloneElement?.parentType,
        };
        postTaggedPYPChildren.push(cloneElement?.fieldUID);
      }
    });

    const isNewGoalTaggingEnabled = getIsNewGoalTaggingEnabled();

    const isElementPypEmpty = _.every(
      _.get(post, "node.elementPYP", []),
      element => _.isEmpty(element?.value)
    );
    updatePost({
      elementPYP: !isElementPypEmpty
        ? _.get(post, "node.elementPYP", null)
        : null,
      unitPlan: _.get(post, "node.unitPlan", null),
      resourceId: _.get(post, "node.resourceId", null),
      resourceType: _.get(post, "node.resourceType", null),
      postTaggedElements: postTaggedPYPChildren,
      selectFromPost: true,
      selectFromAllPYP:
        (_.isNil(unitPlanId) &&
          _.isNil(resourceId) &&
          (isNewGoalTaggingEnabled
            ? !isUnitPlanOrAssessmentTagged(
                _.get(post, "node.postTaggedEntity", [])
              )
            : true)) ||
        (isNewGoalTaggingEnabled
          ? !isUnitPlanOrAssessmentTagged(
              _.get(post, "node.postTaggedEntity", [])
            )
          : !_.get(post, "node.elementPYP", null)),
      resourceItem: _.get(post, "node.resourceItem", null),
      showTagLearningGoalsModal: false,
      isTaggedFromRecentPost: true,
      postTaggedEntity: _.get(post, "node.postTaggedEntity", []),
    });

    goToStep && goToStep("TAG_FROM_ALL_LEARNING_GOALS");
  };

  return (
    <Modal
      hasOverlay={true}
      isOpen={true}
      onClose={e => {
        e?.stopPropagation();
        onCloseClick();
      }}
      shouldCloseOnEsc={true}
      width="480px"
      height="600px"
    >
      <Modal.Header
        title={`${t("journal:tag_learning_elements_from_recent_post")}`}
        style={{ paddingBottom: "0px" }}
      />
      <Modal.Body style={{ paddingTop: "0px", overflowX: "hidden" }}>
        <div className={classes.container}>
          <PostList
            onItemClicked={onPostClicked}
            feedList={feedList}
            t={t}
            showLoaderBar={false}
            curriculumProgramType={curriculumProgramType}
            isUserTypeStudent={userType == "student"}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

const mapActionCreators = {
  updatePost,
};
const mapStateToProps = (state, ownProps) => {
  const userInfo = getUserInfo();
  const courseIdFromParent = _.get(
    ownProps,
    "screenPanelProps.postDetails.courseId"
  );
  const courseId = courseIdFromParent
    ? courseIdFromParent
    : state.teacher.selected_class.selected_course;
  const curriculumProgramType = _.get(
    state,
    "platform.currentCurriculumProgram.type",
    ""
  );
  const userId = _.get(userInfo, "id");
  const userType = userInfo.user_type;
  const organizationId = _.get(userInfo, "org_id");
  const userEntityType = _.get(userInfo, "userEntityType");

  return {
    mode: state.post.postCreationMode,
    courseId,
    curriculumProgramType,
    userId: userInfo.id,
    userType,
    t: ownProps.t,
    feedList: _.get(state, "post.postDetails.postsWithGoals.edges", []),
  };
};

export default compose(
  connect(mapStateToProps, mapActionCreators),
  I18nHOC({ resource: ["common", "journal"] })
)(TagPost);
